// Select all links with the classname
const links = Array.from(document.querySelectorAll('.scrollto'));

// Iterate over each link
links.forEach(link => {
	// Add click event listener
	link.addEventListener('click', (event) => {
		// Prevent the default link behavior
		event.preventDefault();

		// Extract the value of the data-scroll attribute
		const scrollTarget = link.getAttribute('data-scroll');

		// Scroll smoothly to the target element
		document.querySelector(scrollTarget).scrollIntoView({
			behavior: 'smooth'
		});
	});
});

// Select all anchor links on the page
const anchorLinks = Array.from(document.querySelectorAll('a[href^="#"]'));

// Add click event listener to each anchor link
anchorLinks.forEach(link => {
	link.addEventListener('click', (event) => {
		// Prevent the default link behavior
		event.preventDefault();

		// Extract the href attribute value
		const targetId = link.getAttribute('href').slice(1);

		// Find the target element
		const targetElement = document.getElementById(targetId);

		// Scroll smoothly to the target element
		targetElement.scrollIntoView({
			behavior: 'smooth'
		});
	});
});